import Vue from 'vue'
import { GET_PARTNER_SITUATIONS } from '../mutation-types.js'

export const getPartnerSituations = ({ state, dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http.get('partner_situation')
    .then(
      (response) => {
        dispatch(GET_PARTNER_SITUATIONS, response.json())
        resolve()
      },
      (response) => {
        reject()
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/partnerSituationsActions.js